export default __webpack_public_path__ + "static/media/640_private01-fr-mobile.9c7dab0c.png";